/** Default UI language — Chinese for Alipay storefront (landing + React). */
export const getDefaultLanguage = () => 'zh';
